<template>
    <div id="destineDetail">
        <!-- <van-nav-bar title="预订单详情" fixed placeholder left-arrow>
            <a @click="$router.back()" slot="left">
                <i class="iconfont iconfanhuianniu"></i>
            </a>
            <a class="theme-color" v-if="type == 1 && $route.query.type" @click="type = 0" slot="right">审批</a>
            <a class="theme-color" v-if="type == 0 && $route.query.type" @click="type = 1" slot="right">详情</a>
        </van-nav-bar> -->
        <!-- 详情 -->
        <div class="body" v-if="type == 0">
            <div class="title">
                <i class="iconfont iconbookmark"></i> 基本信息
            </div>
            <van-cell title="租客手机号" class="space_bet" >
                  <template #right-icon>
              <a  class="tel" :href="'tel:'+destineDetail.phone">
               <van-icon name="phone" class="search-phone" color="#fd7e2d"  />
               拨打
            </a>
           
          </template>
            </van-cell>
            <van-cell title="租客姓名" :value="destineDetail.name" />
            <van-cell title="房源" :value="destineDetail.roomNo ? destineDetail.houseAddress + destineDetail.roomNo:destineDetail.houseAddress" />
            <van-cell title="预定方式" :value="destineDetail.type == 1?'合租':'整租'" />
            <van-cell title="入住日期" :value="destineDetail.orderDate" />
            <van-cell title="定金" :value="destineDetail.amount+'元'" />
            <van-cell title="状态" :value="destineList[destineDetail.status-1]" />
            <van-cell title="支付状态" :value="payList[destineDetail.createPayStatus-1]" />
            <!-- <van-cell title="退款状态" :value="destineList[destineDetail.cancelPayStatus-1]" /> -->
            <div class="title">
                <i class="iconfont iconbookmark"></i> 退款信息
            </div>
            <van-cell title="是否退款" :value="destineDetail.isRefund==1?'是':destineDetail.isRefund==0?'否':''" />
            <van-cell title="退款金额" :value="destineDetail.cancelAmount" />
            <van-cell title="审批状态" :value="cancelStatusList[destineDetail.cancelStatus-1]" />
            <van-cell title="取消下定原因" :value="destineDetail.cancelRemark" />
        </div>
        <div style="height:1.2rem;" v-if="type == 0"></div>
        <div class="btn" v-if="!$route.query.type">
            <van-button v-if="destineDetail.status == 1 &&(destineDetail.cancelStatus == 2 || !destineDetail.cancelStatus) && $store.state.buttonAuth.indexOf('crm_destineCancel')>-1" class="font4" type="primary" @click="cancel">取消下定</van-button>
            <van-button v-if="destineDetail.status == 1 && destineDetail.createPayStatus == 3 && !destineDetail.contractId && destineDetail.cancelStatus != 3 && $store.state.buttonAuth.indexOf('crm_destineContract')>-1" class="font3" type="primary" @click="contract">转签约</van-button>
            <van-button v-if="destineDetail.cancelStatus && $store.state.buttonAuth.indexOf('crm_destineWorkflow')>-1" class="font4" type="primary" @click="$router.push({path:'approval',query:{businessId:destineDetail.id}})">查看审批</van-button>
        </div>
        <!-- 审批 -->
        <van-steps direction="vertical" :active="0" active-color="#FD7E2D" active-icon="more" inactive-icon="checked" v-if="type == 1">
            <van-step v-for="item in trackRecordList" :key="item.id">
                <!-- 开始 -->
                <div v-if="item.taskStartEndType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item.actorTime">发起时间：{{item.actorTime}}</p>
                    </div>
                </div>
                <!-- 审批 -->
                <div v-else-if="item.taskType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item1.approvalStatus">审批结果：{{approvalStatusList[item1.approvalStatus-1]}}</p>
                        <p v-if="item1.remark">审批意见：{{item1.remark}}</p>
                        <p v-if="item1.approvalTime">处理时间：{{item1.approvalTime}}</p>
                        <p v-if="item1.createTime">到达时间：{{item1.createTime}}</p>
                    </div>
                </div>
                <!-- 抄送 -->
                <div v-else-if="item.taskType == 2">
                    <div>
                        <h4>
                            <span v-for="(item1,index1) in item.actors" :key="index1">
                                <span v-if="index1!=0">/</span>
                                {{item1.actorName}}
                            </span>
                        </h4>
                        <p v-if="item.actors[0]?item.actors[0].createTime:''">到达时间：{{item.actors[0]?item.actors[0].createTime:''}}</p>
                    </div>
                </div>
                <!-- 结束 -->
                <div v-else>结束</div>
                <!-- <h4>
          <span v-for="(item1,index1) in item.actors" :key="index1">
            <span v-if="index1!=0">/</span>
            {{item1.actorName}}
          </span>
        </h4>
        <p v-if="item.actors[0]?item.actors[0].createTime:''">到达时间：{{item.actors[0]?item.actors[0].createTime:''}}</p>-->
            </van-step>
        </van-steps>
        <van-form ref="form" label-width="110px" input-align="left" v-if="type == 1 && trackRecordList[0].status != 5">
            <van-field label="审批意见" :border="false" />
            <van-field v-model="formData.remark" rows="2" autosize type="textarea" maxlength="50" placeholder="请输入审批意见" show-word-limit :rules="[{ required: true, message: '请输入审批意见' }]" />
        </van-form>
        <!-- <div class="btn" v-if="type == 1">
            <van-button block type="default" v-if="type == 1 && trackRecordList[0].status != 5" :loading="saveLoad" :disabled="saveLoad" @click="submit(2)">驳回</van-button>
            <van-button block type="primary" v-if="type == 1 && trackRecordList[0].status != 5" :loading="saveLoad" :disabled="saveLoad" @click="submit(1)">同意</van-button>
        </div> -->
        <div class="btn" v-if="$route.query.type">
            <van-button v-if="type == 0" @click="type = 1" type="primary">审批</van-button>
            <van-button v-if="type == 1" @click="type = 0" type="primary">详情</van-button>
            <van-button block type="primary" v-if="type == 1 && trackRecordList[0].status != 5" :loading="saveLoad" :disabled="saveLoad" @click="submit(2)">驳回</van-button>
            <van-button block type="primary" v-if="type == 1 && trackRecordList[0].status != 5" :loading="saveLoad" :disabled="saveLoad" @click="submit(1)">同意</van-button>
        </div>
        <transition name="van-slide-right">
            <div v-show="showCancel" class="search">
                <van-form @submit="cancelConfirm" ref="cancelForm" label-width="100px" input-align="right">
                    <van-field label="已支付定金" :value="destineDetail.amount+'元'" disabled />
                    <van-field label="是否退款">
                        <template #input>
                            <van-radio-group v-model="cancelQuery.isRefund" direction="horizontal" @change="cancelQuery.cancelAmount = '';cancelQuery.receiptId = '';receiptName = ''">
                                <van-radio :name="1">是</van-radio>
                                <van-radio :name="0">否</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field type="digit" v-if="cancelQuery.isRefund" label="退款金额" name="isRefund" maxlength="5" v-model="cancelQuery.cancelAmount" placeholder="点击填写" :disabled="Boolean(!cancelQuery.isRefund)" :rules="[{ validator :validAmount, message: '请填写退款金额' }]" />
                    <van-field v-if="cancelQuery.isRefund" readonly clickable required name="receipt" :value="receiptName" label="收款账号" placeholder="点击选择>" @click="item => { showReceipt = true }" :rules="[{ required: true, message: '请选择收款账号' }]" />
                    <van-field v-model="cancelQuery.cancelRemark" required name="cancelRemark" rows="2" autosize label="取消原因" type="textarea" maxlength="50" placeholder="请输入取消原因" show-word-limit :rules="[{ required:true, message: '请输入取消原因' }]" />
                    <div style="height:1.2rem;"></div>
                    <div class="bottom">
                        <van-button class="font5" type="default" @click="showCancel = false;">取消</van-button>
                        <van-button class="font5" type="primary" :loading="cancelLoad" :disabled="cancelLoad" native-type="submit">确定</van-button>
                    </div>
                </van-form>
            </div>
        </transition>
        <!-- 收款账号 -->
        <van-popup v-model="showReceipt" position="bottom">
            <van-picker show-toolbar :columns="receiptList" @confirm="(item,index) => { cancelQuery.receiptId = item.id;receiptName = item.text;showReceipt=false;$refs.cancelForm.resetValidation('receipt')}" @cancel="showReceipt = false" />
        </van-popup>
        <!-- 加载 -->
        <div class="loading" v-if="loading"></div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {
    requestDestineContractDetail,
    requestDestineContractCancel,
    requestContractValid,
    requestWorkflowDetail1,
    requestWorkflowSubmit,
    requestAccountSelect,
     changeCompany, //钉钉消息进入详情页需切换公司 获取对应按钮权限
  requestButtomAuth,
} from "@/api";
export default {
    name: "destineDetail",
    data() {
        return {
            destineDetail: {
                phone: "",
                name: "",
                houseAddress: "",
                type: "",
                orderDate: "",
                amount: "",
                status: "",
                isRefund: "",
                cancelAmount: "",
                cancelStatus: "",
                cancelRemark: ""
                // trackRecordList: []
            },
            receiptList: [],
            receiptName: "",
            showReceipt: false,
            showCancel: false,
            cancelQuery: {
                id: "",
                payStatus: "",
                isRefund: 0,
                cancelAmount: "",
                cancelRemark: ""
            },
            cancelLoad: false,
            // showflow: false,
            //审批
            type: 0, //切换0.详情/1.审批
            saveLoad: false,
            trackRecordList: [{ status: "" }],
            processTypeList: [
                "",
                "收房合约",
                "租房合约",
                "收房退租",
                "租房退租"
            ],
            statusList: ["", "审批中", "已完成", "取消", "挂起"],
            loading: true,
            formData: {
                remark: ""
            }
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "destineList",
            "payList",
            "contractList",
            "customerList",
            "cancelStatusList",
            "approvalStatusList"
        ])
    },
    created() {
        this.getDetail();
        if (this.$route.query.type) {
            //待办进入
            this.getWorkflow();
        }
    },
    mounted() {},
    methods: {
        getDetail() {
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中..."
            });
            requestDestineContractDetail(this.$route.query.id)
                .then(res => {
                     changeCompany({ companyId: res.data.companyId }).then(
            (res) => {
              this.$store.dispatch("resetAll", res.data);
              requestButtomAuth().then((res) => {
                this.$store.commit("SET_BUTTON", res.data || []);
              });
            }
          );
                    this.destineDetail = res.data;
                    this.loading = false;
                    this.getAccount(res.data.customerId);
                    toast1.clear();
                    console.log(res);
                })
                .catch(err => {
                    toast1.clear();
                });
        },
        //收款账号
        getAccount(customerId) {
            requestAccountSelect(customerId).then(res => {
                if (res.data) {
                    res.data.forEach(d => {
                        d.text =
                            (d.payType == 3 || d.payType == 4
                                ? d.bankName + " | " + d.bankBranchName
                                : d.payTypeName) +
                            " | " +
                            d.accountName +
                            " | " +
                            d.bankAccount;
                    });
                }
                this.receiptList = res.data || [];
            });
        },
        //查流程
        getWorkflow() {
            //审批待办
            requestWorkflowDetail1(this.$route.query.agentId).then(res => {
                this.trackRecordList = res.data ? res.data : [];
                this.trackRecordList[0].status == 5
                    ? (this.type = 1)
                    : (this.type = 0);
                // this.loading = false;
            });
        },
        //取消下定
        cancel() {
            if (
                this.destineDetail.createPayStatus == 3 ||
                this.destineDetail.createPayStatus == 2
            ) {
                //已支付or部分支付
                this.$refs.cancelForm.resetValidation();
                this.cancelQuery.id = this.destineDetail.id;
                this.cancelQuery.payStatus = this.destineDetail.createPayStatus;
                this.showCancel = true;
            } else {
                //未支付
                this.$dialog
                    .confirm({
                        title: "提示",
                        message: "确认取消？",
                        confirmButtonText: "确定",
                        cancelButtonText: "取消"
                    })
                    .then(() => {
                        let param = {
                            id: this.destineDetail.id,
                            payStatus: 1
                        };
                        requestDestineContractCancel(param)
                            .then(res => {
                                this.$toast.success({
                                    message: "取消成功",
                                    // forbidClick: true,
                                    onClose: () => {}
                                });
                                this.getDetail();
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    })
                    .catch(() => {
                        // on cancel
                    });
                //未支付
            }
        },
        cancelConfirm() {
            if (this.cancelQuery.isRefund) {
                this.$refs.cancelForm.validate().then(valid => {
                    this.cancelLoad = true;
                    requestDestineContractCancel(this.cancelQuery)
                        .then(res => {
                            this.$toast.success({
                                message: "取消成功",
                                // forbidClick: true,
                                onClose: () => {}
                            });
                            this.getDetail();
                            this.showCancel = false;
                            this.cancelLoad = false;
                        })
                        .catch(err => {
                            console.log(err);
                            this.cancelLoad = false;
                        });
                });
            } else {
                this.$refs.cancelForm.validate("cancelRemark").then(err => {
                    if (!err) {
                        this.cancelLoad = true;
                        requestDestineContractCancel(this.cancelQuery)
                            .then(res => {
                                this.$toast.success({
                                    message: "取消成功",
                                    // forbidClick: true,
                                    onClose: () => {}
                                });
                                this.showCancel = false;
                                this.cancelLoad = false;
                                this.getDetail();
                            })
                            .catch(err => {
                                console.log(err);
                                this.cancelLoad = false;
                            });
                    }
                });
            }
        },
        //签约
        contract() {
            requestContractValid(this.destineDetail.id)
                .then(res => {
                    this.$router.push({
                        path: "contractAdd",
                        query: { destineContractId: this.destineDetail.id,ownerType:this.destineDetail.ownerType }
                    });
                })
                .catch(err => {
                    console.log(err);
                });
        },
        //审批提交
        submit(type) {
            let param = {
                agentId: this.$route.query.agentId,
                orderId: this.$route.query.orderId,
                approvalStatus: type,
                remark: this.formData.remark
            };
            if (type == 1) {
                //同意
                this.$dialog.confirm({
                    title: "提示",
                    message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    beforeClose: (action, done) => {
                        if (action === "confirm") {
                            this.saveLoad = true;
                            requestWorkflowSubmit(param)
                                .then(res => {
                                    this.$toast.success("审批成功");
                                    this.getWorkflow();
                                    this.saveLoad = false;
                                    done();
                                })
                                .catch(err => {
                                    this.saveLoad = false;
                                    done(false);
                                });
                        } else {
                            done();
                        }
                    }
                });
            } else {
                //驳回
                this.$refs["form"].validate().then(valid => {
                    this.$dialog.confirm({
                        title: "提示",
                        message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        beforeClose: (action, done) => {
                            if (action === "confirm") {
                                this.saveLoad = true;
                                requestWorkflowSubmit(param)
                                    .then(res => {
                                        this.$toast.success("审批成功");
                                        this.getWorkflow();
                                        this.saveLoad = false;
                                        done();
                                    })
                                    .catch(err => {
                                        this.saveLoad = false;
                                        done(false);
                                    });
                            } else {
                                done();
                            }
                        }
                    });
                });
            }
        },
        //校验
        validAmount() {
            if (this.cancelQuery.isRefund && !this.cancelQuery.cancelAmount) {
                return false;
            } else {
                return true;
            }
        }
    },
    watch: {}
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.body {
    .title {
        text-align: left;
        padding: 0.3rem 0.2rem;
        font-weight: 600;
        font-size: 0.37rem;
    }
}
.theme-color {
    color: $theme-color;
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
    .font4 {
        width: 2.9rem;
    }
    .font3 {
        width: 2.5rem;
    }
    .font2 {
        width: 2.1rem;
    }
}
.search {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background-color: #fff;
    z-index: 99;
    overflow: scroll;
    .van-steps {
        text-align: left;
        padding-left: 2rem;
        /deep/.van-step__title {
            padding-left: 0.3rem;
            p {
                padding-top: 0.2rem;
            }
        }
    }
    .bottom {
        position: fixed;
        bottom: 0;
        display: flex;
        width: 100%;
        /deep/.van-button--primary {
            margin-left: -1px;
            border: none;
            border-radius: 0;
        }
        .font5 {
            width: 51%;
        }
    }
}
.van-steps {
    text-align: left;
    padding-left: 2rem;
    /deep/.van-step__title {
        padding-left: 0.3rem;
        p {
            padding-top: 0.2rem;
        }
    }
}
/deep/.van-field__error-message {
    text-align: right;
}
</style>
